import React, { memo, useEffect, useState, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import CircularProgress from '@material-ui/core/CircularProgress'
import { toast } from 'react-toastify'

import classes from './styles.module.scss'
import { StoreValue, ConfirmEmailForChillPackRecipient } from 'store'
import { parseQuery } from 'utils'

const EmailConfirmed: React.FunctionComponent<any> = () => {
	const history = useHistory()
	const [loading, setLoading] = useState(true)
	const [confirmEmailForChillPackRecipientMutation] = useMutation(
		ConfirmEmailForChillPackRecipient,
	)
	const messageText = useRef(
		'Validarea a fost facuta cu succes! Vei primi un nou e-mail pe care il vei folosi pentru a intra in posesia Chill Pack-ului.',
	)
	const url: { data: string } = parseQuery(window.location.search)
	const buff = Buffer.from(url.data, 'base64')
	const decodedData = buff.toString('utf-8')
	const decodedDataParsed: { id: string; pin: string } =
		JSON.parse(decodedData)

	const goToHomePage = useCallback(() => {
		history.push(`/ro`)
	}, [])

	// mark the email as verified and send the QR code
	useEffect(() => {
		if (loading) {
			confirmEmailForChillPackRecipientMutation({
				variables: {
					chillPackRecipientId: decodedDataParsed.id,
					pin: decodedDataParsed.pin,
				},
			})
				.then(response => {
					setLoading(false)
				})
				.catch(error => {
					toast.error('Ne pare rau...ceva nu a functionat corect.', {
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
					})
					goToHomePage()
				})
		}
	}, [
		confirmEmailForChillPackRecipientMutation,
		decodedDataParsed.pin,
		history,
		loading,
		goToHomePage,
	])

	return loading ? (
		<CircularProgress size={40} style={{ margin: 'auto' }} />
	) : (
		<div className={classes.container}>
			<Row className={classes.infoText} gutter={8}>
				<Col sm={{ span: 24 }}>
					<div className={classes.infoText}>
						{messageText.current}
					</div>
				</Col>
			</Row>
			<Row>
				<Col sm={{ span: 24 }}>
					<div className={classes.button}>
						<Button type="primary" onClick={goToHomePage}>
							{'Pagina principala'}
						</Button>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default memo((props: any) => (
	<StoreValue keys={['user|storeUser']}>
		<EmailConfirmed {...props} />
	</StoreValue>
))
